import { useSelector } from 'react-redux';
import { selectors } from '../../slice';

function useValueMetrics() {
  const { getValuationMetrics } = useSelector(selectors);

  const { data: dataValuationMetrics } = getValuationMetrics;

  const getDefaultValueIndexMetrics = (paramsMetrics) => {
    if (paramsMetrics !== 'multiple') {
      const findDataDefault = dataValuationMetrics.params[paramsMetrics].find(
        (metrics) => metrics.default,
      );
      return findDataDefault ? findDataDefault.fitem_id : '';
    }

    // special case for MULTIPLE
    return Object.keys(dataValuationMetrics.params.multiple)
      .map((i) => {
        const currentMultiple = dataValuationMetrics.params.multiple[i];

        if (Array.isArray(currentMultiple)) {
          const findDataDefault = currentMultiple.find(
            (metrics) => metrics.default,
          );
          return findDataDefault ? findDataDefault.fitem_id : '';
        }

        return currentMultiple && currentMultiple.default
          ? currentMultiple.fitem_id
          : '';
      })
      .filter((multiple) => multiple !== '')[0];
  };

  return {
    metrics: dataValuationMetrics,
    getMetrics: getDefaultValueIndexMetrics,
  };
}

export default useValueMetrics;
